import axios from 'axios';

const prefix = 'FUNDER';

export const GET_RATING_CATEGORIES_SUCCESS = `${prefix}_GET_RATING_CATEGORIES_SUCCESS`;
export const GET_RATING_CATEGORIES_ERROR = `${prefix}_GET_RATING_CATEGORIES_ERROR`;

function getFunderRatingCategoriesSuccess(payload) {
  return {
    type: GET_RATING_CATEGORIES_SUCCESS,
    payload
  };
}

function getFunderRatingCategoriesError(error) {
  return {
    type: GET_RATING_CATEGORIES_ERROR,
    payload: {
      error
    }
  };
}

export function getFunderRatingCategories() {
  return dispatch => {
    return axios
      .get('v4/funder-rating-categories')
      .then(response => response.data)
      .then(data => dispatch(getFunderRatingCategoriesSuccess(data.data)))
      .catch(error => dispatch(getFunderRatingCategoriesError(error)));
  };
}
